/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import Textarea from 'components/Textarea.jsx';

import './styles/Composer.scss';

type Props = {
  error: boolean,
  autoFocus?: ?boolean, // TODO: Something with this
  onChange: Function,
  onFocus?: ?Function,
  onBlur?: ?Function,
  onReturnKeyPress?: (e: SyntheticKeyboardEvent) => boolean,
  placeholder?: ?string,
  value: ?string,
  className: ?string,
  indicator?: any,
  children?: any,
  rows?: number,
};

class Composer extends React.Component {
  props: Props;

  static defaultProps = {
    rows: 1,
  };

  state = {
    focused: false,
  };

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    return shallowCompare(this, nextProps, nextState);
  }

  focus = () => {
    this.refs.textarea.focus();
  };

  clear = () => {
    this.refs.textarea.clear();
  };

  handleTextareaBlur = () => {
    this.setState({ focused: false });
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  };

  handleTextareaFocus = () => {
    this.setState({ focused: true });
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  render() {
    const {
      children,
      error,
      className,
      onChange,
      placeholder,
      indicator,
      onReturnKeyPress,
      rows,
      value,
    } = this.props;

    let content = null;
    if (children && React.Children.toArray(children).length) {
      content = (
        <div className="Composer-content">
          {children}
        </div>
      );
    }

    return (
      <div
        className={cx('Composer', {
          'Composer-focus': this.state.focused,
          'Composer-error': error,
        }, className)}>
        <div className="Composer-input">
          <Textarea
            autogrow
            rows={rows}
            ref="textarea"
            className="Composer-input-textarea"
            onFocus={this.handleTextareaFocus}
            onBlur={this.handleTextareaBlur}
            onReturnKeyPress={onReturnKeyPress}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
          />
          <div className="Composer-input-indicator">
            {indicator}
          </div>
        </div>
        {content}
      </div>
    );
  }
}

export default Composer;



// WEBPACK FOOTER //
// ./src/chat/components/Composer.jsx